import { call, select, put, take, race, delay } from 'redux-saga/effects'
import { executeRequestToQueryAPI } from '@aytm/app/insights/dashboard/lib/fetch'
import staticStore from '@aytm/app/insights/dashboard/stores/static.store'
import { FetchError } from '@aytm/app/insights/dashboard/lib/FetchError'
import {
  AccessKeyDuck,
  DataDuck,
  ACCESS_KEY_ACTIONS,
  DATA_ACTIONS
} from '@aytm/app/insights/dashboard/duckness/InsightsDashboardPool'
import { ERROR_ACTIONS, ErrorDuck } from '@aytm/app/insights/dashboard/duckness/ducks/ErrorDuck'

// Stat Query
export default function* statQuerySaga(request, _accessKey) {
  // All errors within are thrown, all response case errors (except wait) are also thrown
  const queryURL = staticStore.urls.query
  for (;;) {
    try {
      const accessKey = yield select(state => state.accessKey)
      return yield call(executeRequestToQueryAPI, { queryURL, accessKey, ...request })
    } catch (error) {
      if (FetchError.isFetchErrorWithCode(error, 'INVALID_KEY')) {
        // Rethrow to be handled by upper saga
        for (let iteration = 0; iteration < 3; iteration++) {
          yield put(
            AccessKeyDuck.action[ACCESS_KEY_ACTIONS.FETCH_ACCESS_KEY]({ sharedKey: staticStore.currentSharedKey })
          )
          const { timeout } = yield race({
            allowRequest: take(DataDuck.mapActionType(DATA_ACTIONS.ALLOW_REQUEST_SCHEMA)),
            timeout: delay(10000)
          })
          if (!timeout) {
            break
          }
          if (timeout && 2 === iteration) {
            yield put(ErrorDuck.action[ERROR_ACTIONS.SET_ERROR]({ type: 'key', error: 'Access key request timed out' }))
            // TODO: cause cleanup
            return void 0
          }
        }
        continue
      }
      throw error
    }
  }
}
